import React from 'react';
import queryString from 'querystring';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { withLocalize, Translate } from 'react-localize-redux';
import { getHostApi } from '../../store/apiWrapper';
import BbCheckbox from '../styling/bbFormikCheckbox';
import BbInput from '../styling/bbInput';
import classnames from 'classnames'
import ModalInner from '../layoutItems/modalInner';
import NoDataComponent from "./noDataComponent";

import './consentPopup.scss';

class ConsentPopup extends React.Component {
    state = { reconfirmation: false }

    render() {
        return (
            <ModalInner title={this.props.translate('Consent.Title')} close={null}>
                {isNullOrUndefined(this.props.data) && <NoDataComponent />}
                {!isNullOrUndefined(this.props.data) && !this.state.reconfirmation && this.renderConfirmation(this.props.data)}
                {!isNullOrUndefined(this.props.data) && this.state.reconfirmation && this.renderReconfirmation()}
            </ModalInner>
        )
    }

    renderConfirmation(data) {
        return (
            <div className="consent">
                <div className={classnames('consent-text', { 'is-normal': localStorage.locales_url_format === 'normal' })}>
                    <Translate id='Consent.Text1' options={{ renderInnerHtml: true }} />
                    <p>
                        <Translate id='Consent.Text2' options={{ renderInnerHtml: true }} />
                        {this.renderFileLink(data, 'Consent.Text2Link')}
                    </p>
                    <Translate id='Consent.Text3' options={{ renderInnerHtml: true }} />
                </div>
                <div className="consent-form" >
                    <Formik
                        enableReinitialize
                        initialValues={{
                            companyName: data.companyName,
                            ico: data.ico,
                            street: data.street,
                            city: data.city,
                            zip: data.zip,
                            name: data.name,
                            surname: data.surname,
                            phone: data.phone,
                            email: data.email,
                            confirmed: false,
                        }}
                        onSubmit={(values) => this.submitValues(values.confirmed, false)}
                        render={({ values, setFieldValue }) => (
                            <Form>
                                <div className="columns consent-registration">
                                    <div className="column">
                                        <BbInput type='text' name='companyName' label={this.props.translate('Consent.RegistrationDetails')} disabled />
                                    </div>
                                    <div className="column">
                                        <BbInput type='text' name='ico' label={""} disabled />
                                    </div>
                                </div>
                                <div className="columns">
                                    <div className="column">
                                        <BbInput type='text' name='street' label={this.props.translate('Consent.Address')} disabled />
                                        <BbInput type='text' name='city' label={""} disabled />
                                        <BbInput type='text' name='zip' label={""} disabled />
                                    </div>
                                    <div className="column">
                                        <BbInput type='text' name='name' label={this.props.translate('Consent.ContactPerson')} disabled />
                                        <BbInput type='text' name='surname' label={""} disabled />
                                        <BbInput type='text' name='phone' label={""} disabled />
                                        <BbInput type='text' name='email' label={""} disabled />
                                    </div>
                                </div>
                                <div className="field bb-field user-specific-info">
                                    <div className="columns">
                                        <div className="column">
                                            <div className="consent-checkbox">
                                                <BbCheckbox id='confirmed' name='confirmed' label={this.props.translate('Consent.Confirmation')} />
                                                {this.renderFileLink(data, 'Consent.ConfirmationLink')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='column is-narrow text-align-center'>
                                    <button type="submit" className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                        <Translate id='Common.Continue' />
                                    </button>
                                </div>
                            </Form>
                        )} />
                </div>
            </div>
        );
    }

    submitValues(confirmed, forced) {
        if (confirmed || forced) {
            this.props.ok(confirmed);
        } else {
            this.setState({ reconfirmation: true })
        }
    }

    renderReconfirmation() {
        return (
            <>
                <p><Translate id='Consent.Warning' /></p>
                <p><Translate id='Consent.Reconfirmation' /></p>
                <div style={{ textAlign: 'center', margin: '1em 0' }} >
                    <button className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.setState({ reconfirmation: false })}>
                        <Translate id='Common.Back' />
                    </button>
                    <button type="submit" className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => { this.submitValues(false, true) }}>
                        <Translate id='Common.Confirm' />
                    </button>
                </div>
            </>
        )
    }

    renderFileLink(data, translateKey) {
        if (isNullOrUndefined(data.file))
            return <a className="link-internal" style={{ cursor: "not-allowed" }}><Translate id={translateKey} /></a>;

        return (
            <a className="link-internal" title={data.file.documentName}
                onClick={() => window.open(
                    `${getHostApi()}/api/account/consent/document/${data.file.year}/${data.file.documentName}/${data.file.type}?${this.getAllParams({})}`, "_blank")}
            >
                <Translate id={translateKey} />
            </a>
        );
    }

    getAllParams = (params) => {
        params["t"] = Date.now();
        params["lang"] = this.props.language;

        if (!isNullOrUndefined(this.props.auth))    // This condition is never met
            params["access_token"] = this.props.auth.token;

        return queryString.stringify(params);
    }
}

export default withLocalize(connect(
    state => ({ language: state.userContext.language, auth: state.userContext.authentication }),
)(ConsentPopup));